import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import activeArianne from "../../img/activeArianne.png";
import unslectArianne from "../../img/unslectArianne.png";
import { stepDirect } from "../../actions/step";

const unactive = {
  display: "none"
};

const nobackground = {
  backgroundImage: "none"
};

class ClassAriane extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.generateProject = this.generateProject.bind(this);
  }
  generateProject() {
    if (this.props.inquires.home.type === "demande") {
      if (this.props.inquires.demande.appointment === "telephone") {
        return <div>Rendez-vous téléphonique</div>;
      } else {
        return (
          <div>
            Rendez-vous en chez mon distributeur
            <br />
            {this.props.inquires.demande.test === "oui"
              ? "Avec essai"
              : "Sans essai"}
          </div>
        );
      }
    } else {
      if (this.props.inquires.achat.test === "oui") {
        return <div>
          Avec essai<br />
          Projet d’achat dans les {(this.props.inquires.achat.purchaseTime.label).toLowerCase()}<br />
          {this.props.inquires.achat.financing === "oui"
              ? "Intérêt pour un financement"
              : "Sans mode de financement"}<br />
          {this.props.inquires.achat.customerSeat === "oui"
              ? "Déjà client SEAT"
              : "Pas encore client SEAT"}<br />
        </div>;
      }else{
        return <div>
        Sans essai<br />
        {this.props.inquires.achat.appointment === "telephone"
            ? "Rendez-vous téléphonique"
            : "Rendez-vous chez mon distributeur"}<br />
        Projet d’achat dans les {(this.props.inquires.achat.purchaseTime.label).toLowerCase()}<br />
        {this.props.inquires.achat.financing === "oui"
            ? "Intérêt pour un financement"
            : "Sans mode de financement"}<br />
        {this.props.inquires.achat.customerSeat === "oui"
            ? "Déjà client SEAT"
            : "Pas encore client SEAT"}<br />
      </div>;
      }
    }
  }
  handleClick(n) {
    this.props.stepDirect(n, "/module");
  }
  render() {
    return (
      <div className="ariane">
        <div className="arianetitle colorGrey3 fontBold">
          {this.props.inquires.home.type === "achat"
            ? "Votre projet d’achat"
            : "Votre demande d'informations"}
        </div>
        <div
          className="arianeSubContent"
          style={this.props.step.pageNumber >= 5 ? nobackground : null}
        >
          <div className="arianeCacheTop" />
          <div className="arianeTop">
            <div
              className="arianeCacheLast"
              style={this.props.step.pageNumber >= 5 ? null : unactive}
            />
            <div className="arianeStepTop">
              <div
                className="arianeStep"
                style={this.props.step.pageNumber >= 1 ? unactive : null}
              >
                <img alt="" className="arianeDotActive" src={activeArianne} />
                <div className="arianeStepTxtActive colorGrey3 fontLight">
                  <span className="subtitle">Votre</span>
                  <span className="title">Projet</span>
                </div>
              </div>
              <div
                className="arianeStep"
                style={this.props.step.pageNumber < 1 ? unactive : null}
              >
                <img
                  alt=""
                  className="arianeDotUnactive"
                  src={unslectArianne}
                />
                <div className="arianeStepTxtUnactive">
                  <div
                    className={
                      "title colorGrey3 fontLight arianelink" +
                      (this.props.step.pageNumber !== 5
                        ? " arianelinkhover"
                        : null)
                    }
                    onClick={
                      this.props.step.pageNumber >= 1 &&
                      this.props.step.pageNumber !== 5
                        ? e => this.handleClick(0)
                        : null
                    }
                  >
                    Votre Projet
                  </div>
                  <div
                    // style={this.props.step.pageNumber === 1 ? null : unactive}
                  >
                    <div className="information colorRed fontBold">
                      {this.generateProject()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="arianeStepTop"
              style={this.props.step.pageNumber >= 1 ? null : unactive}
            >
              <div
                className="arianeStep"
                style={this.props.step.pageNumber !== 1 ? unactive : null}
              >
                <img alt="" className="arianeDotActive" src={activeArianne} />
                <div className="arianeStepTxtActive colorGrey3 fontLight">
                  <span className="subtitle">Informations</span>
                  <span className="title">Personnelles</span>
                </div>
              </div>
              <div
                className="arianeStep"
                style={this.props.step.pageNumber < 2 ? unactive : null}
              >
                <img
                  alt=""
                  className="arianeDotUnactive"
                  src={unslectArianne}
                />
                <div className="arianeStepTxtUnactive">
                  <div
                    className={
                      "title colorGrey3 fontLight arianelink" +
                      (this.props.step.pageNumber !== 5
                        ? " arianelinkhover"
                        : null)
                    }
                    onClick={
                      this.props.step.pageNumber >= 2 &&
                      this.props.step.pageNumber !== 5
                        ? e => this.handleClick(1)
                        : null
                    }
                  >
                    Informations Personnelles
                  </div>
                  <div
                    // style={this.props.step.pageNumber === 2 ? null : unactive}
                  >
                    <div className="information colorGrey3 fontBold">
                      {this.props.inquires.user["civility"] === "Monsieur"
                        ? "Mr "
                        : "Md "}
                      {this.props.inquires.user["lastname"] + " "}
                      {this.props.inquires.user["firstname"]}
                      <br />
                      <span className="fontBook">
                        {this.props.inquires.user["email"]}
                        <br />
                        {this.props.inquires.user["phone_number"]}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="arianeStepTop"
              style={this.props.step.pageNumber >= 2 ? null : unactive}
            >
              <div
                className="arianeStep"
                style={this.props.step.pageNumber !== 2 ? unactive : null}
              >
                <img alt="" className="arianeDotActive" src={activeArianne} />
                <div className="arianeStepTxtActive colorGrey3 fontLight">
                  <span className="subtitle">Choix du</span>
                  <span className="title">Véhicule</span>
                </div>
              </div>
              <div
                className="arianeStep"
                style={this.props.step.pageNumber < 3 ? unactive : null}
              >
                <img
                  alt=""
                  className="arianeDotUnactive"
                  src={unslectArianne}
                />
                <div className="arianeStepTxtUnactive">
                  <div
                    className={
                      "title colorGrey3 fontLight arianelink" +
                      (this.props.step.pageNumber !== 5
                        ? " arianelinkhover"
                        : null)
                    }
                    onClick={
                      this.props.step.pageNumber >= 3 &&
                      this.props.step.pageNumber !== 5
                        ? e => this.handleClick(2)
                        : null
                    }
                  >
                    Choix du Véhicule
                  </div>
                  <div
                    // style={this.props.step.pageNumber === 3 ? null : unactive}
                  >
                    <div className="information colorRed fontBold">
                      {this.props.restIntel.intel.carInfo}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="arianeStepTop"
              style={this.props.step.pageNumber >= 3 ? null : unactive}
            >
              <div
                className="arianeStep"
                style={this.props.step.pageNumber !== 3 ? unactive : null}
              >
                <img alt="" className="arianeDotActive" src={activeArianne} />
                <div className="arianeStepTxtActive colorGrey3 fontLight">
                  <span className="subtitle">Choix du</span>
                  <span className="title">Distributeur</span>
                </div>
              </div>
              <div
                className="arianeStep"
                style={this.props.step.pageNumber < 4 ? unactive : null}
              >
                <img
                  alt=""
                  className="arianeDotUnactive"
                  src={unslectArianne}
                />
                <div className="arianeStepTxtUnactive">
                  <div
                    className={
                      "title colorGrey3 fontLight arianelink" +
                      (this.props.step.pageNumber !== 5
                        ? " arianelinkhover"
                        : null)
                    }
                    onClick={
                      this.props.step.pageNumber >= 4 &&
                      this.props.step.pageNumber !== 5
                        ? e => this.handleClick(3)
                        : null
                    }
                  >
                    Choix du Distributeur
                  </div>
                  <div
                    // style={this.props.step.pageNumber === 4 ? null : unactive}
                  >
                    <div className="information colorRed fontBold">
                      {this.props.restIntel.intel.dealerInfo.proFullName}
                      <br />
                      <span div className="colorGrey3 fontBook">
                        {this.props.restIntel.intel.dealerInfo.city +
                          " " +
                          this.props.restIntel.intel.dealerInfo.zipCode}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="arianeStepTop"
              style={this.props.step.pageNumber >= 4 ? null : unactive}
            >
              <div
                className="arianeStep"
                style={this.props.step.pageNumber !== 4 ? unactive : null}
              >
                <img alt="" className="arianeDotActive" src={activeArianne} />
                <div className="arianeStepTxtActive colorGrey3 fontLight">
                  <span className="subtitle">Choix du</span>
                  <span className="title">Rendez-vous</span>
                </div>
              </div>
              <div
                className="arianeStep"
                style={this.props.step.pageNumber < 5 ? unactive : null}
              >
                <img
                  alt=""
                  className="arianeDotUnactive"
                  src={unslectArianne}
                />
                <div className="arianeStepTxtUnactive">
                  <div
                    className={
                      "title colorGrey3 fontLight arianelink" +
                      (this.props.step.pageNumber !== 5
                        ? " arianelinkhover"
                        : null)
                    }
                    onClick={
                      this.props.step.pageNumber >= 5 &&
                      this.props.step.pageNumber !== 5
                        ? e => this.handleClick(4)
                        : null
                    }
                  >
                    Choix du Rendez-vous
                  </div>
                  <div
                    style={this.props.step.pageNumber === 5 ? null : unactive}
                  >
                    <div className="information colorRed fontBold">
                      {this.props.restIntel.intel.timeInfo.dayLet +
                        " " +
                        this.props.restIntel.intel.timeInfo.dayNum +
                        " " +
                        this.props.restIntel.intel.timeInfo.month +
                        " " +
                        this.props.restIntel.intel.timeInfo.time}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="arianeStepTop"
              style={this.props.step.pageNumber >= 5 ? null : unactive}
            >
              <div
                className="arianeStep"
                style={this.props.step.pageNumber !== 5 ? unactive : null}
              >
                <img alt="" className="arianeDotActive" src={activeArianne} />
                <div className="arianeStepTxtActive colorGrey3 fontLight">
                  <span className="subtitle">Votre</span>
                  <span className="title">Rendez-vous</span>
                </div>
              </div>
              {/* <div
                className="arianeStep"
                style={this.props.step.pageNumber < 6 ? unactive : null}
              >
                <img
                  alt=""
                  className="arianeDotUnactive"
                  src={unslectArianne}
                />
              </div> */}
            </div>
          </div>
          <div className="arianeBottom">
            <div
              className="arianeStep arianeStepBottom"
              style={this.props.step.pageNumber >= 1 ? unactive : null}
            >
              <img alt="" className="arianeDotUnactive" src={unslectArianne} />
              <div className="arianeStepTxtUnactive fadeTxt colorGrey3 fontLight">
                Informations personnelles
              </div>
            </div>
            <div
              className="arianeStep arianeStepBottom"
              style={this.props.step.pageNumber >= 2 ? unactive : null}
            >
              <img alt="" className="arianeDotUnactive" src={unslectArianne} />
              <div className="arianeStepTxtUnactive fadeTxt colorGrey3 fontLight">
                Choix du véhicule
              </div>
            </div>
            <div
              className="arianeStep arianeStepBottom"
              style={this.props.step.pageNumber >= 3 ? unactive : null}
            >
              <img alt="" className="arianeDotUnactive" src={unslectArianne} />
              <div className="arianeStepTxtUnactive fadeTxt colorGrey3 fontLight">
                Choix du distributeur
              </div>
            </div>
            <div
              className="arianeStep arianeStepBottom"
              style={this.props.step.pageNumber >= 4 ? unactive : null}
            >
              <img alt="" className="arianeDotUnactive" src={unslectArianne} />
              <div className="arianeStepTxtUnactive fadeTxt colorGrey3 fontLight">
                Choix du rendez-vous
              </div>
            </div>
            <div
              className="arianeStep arianeStepBottom"
              style={this.props.step.pageNumber >= 5 ? unactive : null}
            >
              <img alt="" className="arianeDotUnactive" src={unslectArianne} />
              <div className="arianeStepTxtUnactive fadeTxt colorGrey3 fontLight">
                Votre rendez-vous
              </div>
              <div className="arianeCacheBottom" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      stepDirect
    },
    dispatch
  );

export const Ariane = connect(
  mapStateToProps,
  mapDispatchToProps
)(ClassAriane);



// WEBPACK FOOTER //
// ./src/containers/components/Ariane.js